export const UNAUTHORIZED_ERROR = "UNAUTHORIZED";

// The backend rejects a stale-admin token with this message once the user's
// live role no longer permits the request (UP-2939). /api/role never returns it
// and is the endpoint we re-fetch the role from, so exclude it to avoid a loop.
export function shouldReSyncRole(errorText: string, path: string): boolean {
  return errorText === UNAUTHORIZED_ERROR && !path.endsWith("/api/role");
}

export const ACCOUNT_DEACTIVATED_ERROR = "ACCOUNT_DEACTIVATED";

// The backend rejects every authenticated request from a member of a
// deactivated account with this message (UP-2973). Any such response signs the
// user out, regardless of which endpoint produced it.
export function isAccountDeactivatedError(errorText: string): boolean {
  return errorText === ACCOUNT_DEACTIVATED_ERROR;
}

// True when a thrown API error is the backend's UNAUTHORIZED guard. Used to
// surface a friendly message when a non-primary therapist edits a client's
// content (only the primary therapist may manage content — see UP-2952/UP-2889).
export function isUnauthorizedError(error: unknown): boolean {
  if (error instanceof Error) return error.message === UNAUTHORIZED_ERROR;
  return error === UNAUTHORIZED_ERROR;
}
